const USER_STORAGE_KEY = 'user'
const MENUS_STORAGE_KEY = 'menus'

function readStoredValue(key, fallback) {
    if (typeof localStorage === 'undefined') return fallback

    try {
        const value = localStorage.getItem(key)
        return value ? JSON.parse(value) : fallback
    } catch (error) {
        return fallback
    }
}

function readSession() {
    const session = readStoredValue(USER_STORAGE_KEY, null)
    return session && typeof session === 'object' ? session : null
}

function readMenus(session) {
    const storedMenus = readStoredValue(MENUS_STORAGE_KEY, null)
    if (Array.isArray(storedMenus)) return storedMenus
    return session && Array.isArray(session.menus) ? session.menus : []
}

function persistSession(session, menus) {
    if (typeof localStorage === 'undefined') return

    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(session))
    localStorage.setItem(MENUS_STORAGE_KEY, JSON.stringify(menus))
}

function hasStoredValue(key) {
    if (typeof localStorage === 'undefined') return false

    try {
        return localStorage.getItem(key) !== null
    } catch (error) {
        return false
    }
}

const initialSession = readSession()
const initialMenus = readMenus(initialSession)
const hasStoredMenus = hasStoredValue(MENUS_STORAGE_KEY)
    || Boolean(initialSession && Array.isArray(initialSession.menus))

export default {
    namespaced: true,
    state: () => ({
        session: initialSession,
        profile: null,
        menus: initialMenus,
        hasMenus: hasStoredMenus
    }),
    getters: {
        currentUser(state) {
            return Object.assign({}, state.session || {}, state.profile || {})
        },
        username(state, getters) {
            return getters.currentUser.username || ''
        },
        token(state) {
            return state.session && state.session.token || ''
        },
        isAuthenticated(state) {
            return Boolean(state.session)
        }
    },
    mutations: {
        setSession(state, session) {
            state.session = session
            state.menus = session && Array.isArray(session.menus) ? session.menus : state.menus
            state.hasMenus = true
            state.profile = null
        },
        setProfile(state, profile) {
            state.profile = profile
        },
        clearSession(state) {
            state.session = null
            state.profile = null
            state.menus = []
            state.hasMenus = false
        }
    },
    actions: {
        saveSession({ commit }, session) {
            const menus = session && Array.isArray(session.menus) ? session.menus : []
            persistSession(session, menus)
            commit('setSession', session)
        },
        updateProfile({ commit, state }, profile) {
            if (!state.session) return

            const session = {
                ...state.session,
                ...profile,
                token: state.session.token
            }
            persistSession(session, state.menus)
            commit('setSession', session)
            commit('setProfile', profile)
        }
    }
}
